import React, { useRef, useState, useEffect } from "react";
import useHttp from "../../../hooks/use-http";

import { toast } from "react-toastify";
import moment from "moment";

const AgronomyRecommendationForm = (props) => {
  const frmRef = useRef({});

  const { sendRequest: getAgronomy } = useHttp();
  const [agronomyData, setAgronomyData] = useState("");
  const [agronomyId, setagronomyId] = useState(0);
  const [cropPlotId, setcropPlotId] = useState(0);

  const [agronomyItem, setAgronomyItem] = useState("");
  const [images, setImages] = useState();

  const [sliderImages, setSliderImages] = useState([""]);

  const [selectedDate, setSelectedDate] = useState(
    new Date().toISOString().substr(0, 10)
  );

  const handleDateChange = (e) => {
    setSelectedDate(e.target.value);
  };

  const currentDate = new Date().toISOString().slice(0, 10);

  const handleRecommendation = (index, e) => {
    setSliderImages([""]);

    var item = agronomyData.filter((v, i) => i == index);

    if (item.length > 0) {
      ////console.log(item[0].agronomyId);

      setagronomyId(item[0].agronomyId);
      setcropPlotId(item[0].cropPlotId);
      frmRef.current.Observation.value = item[0].description;
    }
    var itemobj = item[0];
    setAgronomyItem(itemobj);
    console.log("cropObservation", itemobj.cropObservation);
    if ((itemobj.cropObservation ?? "") != "") {
      var cropObservationJs = JSON.parse(itemobj.cropObservation);
      console.log(
        "cropAttachment",
        cropObservationJs.cropObservationAttachment
      );
      var newimg = [];
      var cropAttachment = JSON.parse(
        cropObservationJs.cropObservationAttachment
      );
      cropAttachment.forEach((item) => {
        newimg = newimg.concat(item.urlAttachments);
      });
      //console.log("newimg",newimg)
      setImages(newimg);

      if (newimg) {
        const baseFileUrl = process.env.REACT_APP_FILE_URL;
        const imagesWithBaseUrl = newimg.map(
          (filePath) => baseFileUrl + filePath
        );

        //console.log("imagesWithBaseUrl",imagesWithBaseUrl)
        if (imagesWithBaseUrl.length > 0) {
          setSliderImages(imagesWithBaseUrl);
        }
      } else {
        setSliderImages([""]);
      }
    } else {
      //console.log("item",item)
      const files = item[0] && item[0].urlAttachments;
      const url = JSON.parse(files);
      //console.log("url",files)
      setImages(url);

      if (url) {
        const baseFileUrl = process.env.REACT_APP_FILE_URL;
        const imagesWithBaseUrl = url.map((filePath) => baseFileUrl + filePath);

        if (imagesWithBaseUrl.length > 0) {
          setSliderImages(imagesWithBaseUrl);
        }
      } else {
        setSliderImages([""]);
      }
    }
  };
  useEffect(() => {
    getAgronomy(
      {
        url: `/api/farmerAgronomyRecommendation/`,
      },

      (res) => {
        if (res) {
          console.log("getFarmerCropdDashBoard", res);

          setAgronomyData(res);
          var cropDashboardDetails = res;
          const aData = cropDashboardDetails.filter(
            (item) => (item.agronomy || "") != ""
          );

          var newagronomylist = [];
          var k = 0;
          do {
            var croppltdata = aData[k];

            const agronomy = JSON.stringify(croppltdata.agronomy);

            const agronomyData = JSON.parse(JSON.parse(agronomy));

            var agronomyrequired = agronomyData.filter(
              (item) => (item.recommendation ?? "") == ""
            );

            //   ////console.log("agronomyrequired", agronomyrequired);

            if (agronomyrequired.length > 0) {
              var i = 0;
              do {
                var agronomyiten = agronomyrequired[i];
                // ////console.log(
                //   " agronomyiten cropObservation",
                //   agronomyiten.cropObservation
                // );

                var strcropObservation = JSON.stringify(
                  agronomyiten.cropObservation
                );

                var cropObservation = JSON.parse(
                  JSON.parse(strcropObservation)
                );
                //console.log("agronomyiten", agronomyiten.agronomyId);
                //console.log("strcropObservation",cropObservation);
                newagronomylist = newagronomylist.concat({
                  agronomyId: agronomyiten.agronomyId,
                  farmerId: croppltdata.farmerId,
                  fieldExecutiveName: croppltdata.fieldExecutiveName,
                  farmerName: croppltdata.farmerName,
                  farmerNo: croppltdata.farmerNo,
                  regionName: croppltdata.regionName,
                  plotId: croppltdata.plotId,
                  plotName: croppltdata.plotName,
                  cropPlotId: croppltdata.cropPlotId,
                  plotArea: croppltdata.plotArea,

                  plotAreaUnit: croppltdata.plotAreaUnit,

                  cropId: croppltdata.cropId,

                  cropName: croppltdata.cropName,

                  cropType: croppltdata.cropType,
                  cropVariety: croppltdata.cropVariety,
                  sowingDate: croppltdata.sowingDate,
                  pruningDate: croppltdata.pruningDate,
                  harvestingDate: croppltdata.harvestingDate,
                  surveyNumberGutNumber: croppltdata.harvestingDate,

                  cropObservation: cropObservation.description,
                  cropobservationDate: agronomyiten.date,

                  fileAttachments: cropObservation.fileAttachments,
                  urlAttachments: cropObservation.urlAttachments,
                  cropObservationAttachment:
                    cropObservation.cropObservationAttachment,
                  recommendation: agronomyiten.recommendation,
                });

                i++;
              } while (agronomyrequired.length > i);
            }

            k++;
          } while (aData.length > k);

          //console.log("newagronomylist", newagronomylist);

          setAgronomyData(newagronomylist);

          var fileAttachments = JSON.parse(cropObservation.fileAttachments);
          var kb = 0;
          do {
            fileAttachments[kb] =
              "https://farmmobi-img-dev.s3.ap-south-1.amazonaws.com" +
              fileAttachments[kb];

            kb++;
          } while (fileAttachments.length > kb);
        }
      }
    );
  }, [getAgronomy]);

  const { sendRequest: updateRecommendation } = useHttp();

  const submitHandler = (e) => {
    e.preventDefault();

    //   ////console.log("id", agronomyData[0].agronomyId);

    const data = {
      cropId: cropPlotId,
      agronomyId: agronomyId,
      recommendation: frmRef.current.recommendation.value,
      recommendationDate: moment(
        frmRef.current.recommendationDate.value
      ).format("DD/MM/YYYY"),
      recommendationBy: parseInt(localStorage.getItem("empId")),
    };

    ////console.log(data);
    updateRecommendation(
      {
        url: "/api/updateRecommendation/",
        method: "POST",
        body: data,
      },
      (data) => {
        toast.success("Update Recommendation");
      },
      (error) => {
        // ////console.log(error);
        toast.error("error");
      }
    );
  };

  return (
    <>
      <div className="content-wrapper">
        <div>&nbsp;</div>
        <section className="content">
          <div className="container-fluid">
            {/* SELECT2 EXAMPLE */}
            <div className="card card-default">
              <div className="card-header">
                <h3 className="card-title">Agronomy Recommendation Details</h3>
                <div className="card-tools">
                  <button
                    type="button"
                    className="btn btn-tool"
                    data-card-widget="remove"
                    onClick={() => props.addForm(false)}
                  >
                    <i className="fas fa-times" />
                  </button>
                </div>
              </div>
              {/* /.card-header */}
              <div className="card-body">
                <div className="row">
                  <div className="col-md-4">
                    <label>Farmer Name</label> :{" "}
                    {agronomyItem && agronomyItem.farmerName}
                  </div>

                  <div className="col-md-4">
                    <label>Crop Name</label> :{" "}
                    {agronomyItem && agronomyItem.cropName}
                  </div>

                  <div className="col-md-4">
                    <label>Variety Name</label> :{" "}
                    {agronomyItem && agronomyItem.varietyName}
                  </div>
                </div>
                <div className="row">
                  <div className="col-md-4">
                    <label>Field Operation</label> :{" "}
                    {agronomyItem && agronomyItem.fieldOperationName}
                  </div>

                  <div className="col-md-4">
                    <label>Field Operation Date</label> :{" "}
                    {agronomyItem && agronomyItem.fieldOperationDate}
                  </div>

                  <div className="col-md-4">
                    <label>Field Operation Description</label> :{" "}
                    {agronomyItem && agronomyItem.fieldOperationDescription}
                  </div>
                </div>
                <div className="row">
                  <div className="col-md-4">
                    <label>Plant Count</label> :{" "}
                    {agronomyItem && agronomyItem.plantCount}
                  </div>

                  <div className="col-md-4">
                    <label>Average Leave Per Tree</label> :{" "}
                    {agronomyItem && agronomyItem.averageLeavesPerPlant}
                  </div>

                  <div className="col-md-4">
                    <label>Disease/Insect/Pest Observed</label> :{" "}
                    {agronomyItem && agronomyItem.insectDiseasePestName}
                  </div>
                  <div className="col-md-4">
                    <label>Affected Area</label> :{" "}
                    {agronomyItem && agronomyItem.affectedArea}
                  </div>
                </div>

                <div className="row">
                  <div className="col-md-12">
                    <div className="form-group">
                      {images &&
                        images.map((filePath, index) => (
                          <img
                            key={index}
                            alt={`Image ${index}`}
                            src={`${process.env.REACT_APP_FILE_URL}${filePath}`}
                            height="200"
                            width="200"
                            className="mx-2 my-2"
                          />
                        ))}
                    </div>
                  </div>
                </div>
                <form onSubmit={submitHandler}>
                  <div className="row">
                    <div className="col-md-4">
                      <label>Observation</label>

                      <input
                        type="text"
                        id="recommendation"
                        readOnly
                        className="form-control"
                        ref={(el) => (frmRef.current["Observation"] = el)}
                        autoComplete="off"
                      />
                    </div>

                    <div className="col-md-3">
                      <label htmlFor={"date"}> {"Recommendation Date"}</label>
                      <input
                        type={"date"}
                        id={"recommendationDate"}
                        required
                        readOnly
                        ref={(el) =>
                          (frmRef.current["recommendationDate"] = el)
                        }
                        className="form-control"
                        max={currentDate}
                        value={selectedDate}
                        onChange={handleDateChange}
                      />
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-md-6">
                      <label>Recommendation </label>
                      <input
                        type="text"
                        id="recommendation"
                        className="form-control"
                        ref={(el) => (frmRef.current["recommendation"] = el)}
                        autoComplete="off"
                      />
                    </div>
                    <div className="col-md-4">
                      <br />
                      <button className="btn btn-primary">Submit</button>
                    </div>
                  </div>
                </form>
                <br />
                <div className="row">
                  <table className="table table-bordered table-responsive">
                    <thead>
                      <tr>
                        <th>Crop Observation Date</th>
                        <th>Farmer Name</th>
                        <th>Farmer No</th>
                        <th>Plot Area</th>
                        <th>Crop Name</th>
                        <th>Observation</th>
                        <th>Recommendation</th>

                        <th>Supervisor Employee</th>

                        <th></th>
                      </tr>
                    </thead>
                    <tbody>
                      {agronomyData &&
                        agronomyData.map((itm, i) => (
                          <tr key={i}>
                            <td>{itm.date}</td>

                            <td>{itm.farmerName}</td>

                            <td>{itm.farmerNo}</td>

                            <td>
                              {itm.plotArea} &nbsp; {itm.plotAreaUnit}
                            </td>
                            <td>{itm.cropName}</td>
                            <td>{itm.description}</td>
                            <td>{itm.recommendation}</td>
                            <td>{itm.fieldExecutiveName}</td>

                            <td>
                              <button
                                className="btn btn-sm btn-success"
                                onClick={(e) => handleRecommendation(i, e)}
                              >
                                Recommendation
                              </button>
                            </td>
                          </tr>
                        ))}
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
    </>
  );
};

export default AgronomyRecommendationForm;
